import type { IImpersonationStore } from "@ports/storage/IImpersonationStore";

const SESSION_KEY = "rogo_impersonated_email";

/**
 * Browser adapter for the `IImpersonationStore` port. Backs the slot with
 * `sessionStorage` so impersonation does not survive a tab close.
 */
export const browserImpersonationStore: IImpersonationStore = {
	get: () => sessionStorage.getItem(SESSION_KEY) || null,
	set: (email) => sessionStorage.setItem(SESSION_KEY, email),
	clear: () => sessionStorage.removeItem(SESSION_KEY),
};

// Legacy free-function exports — kept so the existing call sites
// (`@infra/api/common`'s authorization-header builder, the React-binding
// `ImpersonationContext.vm.ts`, and the legacy `src/hooks/ImpersonationContext/` bridge (removed))
// keep compiling without immediate refactor.
export function getImpersonatedEmail(): string | null {
	return browserImpersonationStore.get();
}
export function setImpersonatedEmail(email: string): void {
	browserImpersonationStore.set(email);
}
export function clearImpersonatedEmail(): void {
	browserImpersonationStore.clear();
}
